import React from "react";
import useUniqueId from "../../../hooks/use-unique-id";

const WalletBadgeIcon = ({ title }) => {
  const gradientId = useUniqueId("wallet-badge-gradient");
  return (
    <svg
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : "true"}
      aria-label={title || undefined}
      width="64"
      height="64"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {title && <title>{title}</title>}
      <rect y="16" width="64" height="48" rx="6" fill="#317D4F" />
      <path
        d="M0 22C0 18.6863 2.68629 16 6 16H58C61.3137 16 64 18.6863 64 22V29H0V22Z"
        fill={`url(#${gradientId})`}
        fillOpacity="0.2"
      />
      <path
        d="M10 4C10 1.79086 11.7909 0 14 0H50C52.2091 0 54 1.79086 54 4V29H10V4Z"
        fill="#D0C7FD"
      />
      <rect x="37" width="8" height="29" fill="#3B414D" />
      <path
        d="M16 7.5C16 6.39543 16.8954 5.5 18 5.5C19.1046 5.5 20 6.39543 20 7.5V13.5C20 14.6046 19.1046 15.5 18 15.5C16.8954 15.5 16 14.6046 16 13.5V7.5Z"
        fill="#3B414D"
      />
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="29"
          x2="0"
          y2="16"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stopOpacity="0.05" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default WalletBadgeIcon;
